import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTenant } from "../Context/TenantContext";
 
const ThankYouPage = () => {
 const navigate = useNavigate();
 const { tenant } = useTenant();
 
 useEffect(() => {
 const timer = setTimeout(() => {
     navigate('/dashboard');
 }, 5000);
 
 return () => clearTimeout(timer); // Cleanup timer on unmount
 }, [navigate, tenant]);
 
 return (
 <div className="min-h-screen bg-bgMain text-body flex flex-col items-center justify-center px-6 py-20 font-sans text-center">
 <div className="max-w-2xl bg-bgSection p-10 md:p-16 rounded-3xl shadow-2xl border border-accentGray/30 relative overflow-hidden">
 {/* Background glow */}
 <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl -mr-32 -mt-32"></div>
 
 <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-8 animate-bounce">
 <span className="text-4xl">🎉</span>
 </div>
 
 <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-8">
 Thank You for Enrolling!
 </h1>
 
 <p className="text-xl text-body font-medium mb-6">
 We're thrilled to have you on board for the Skill Genie Bootcamp.
 </p>
 
 <p className="text-lg text-muted mb-10 leading-relaxed">
 Our team will reach out to you soon with next steps, onboarding instructions, and your batch schedule.
 </p>
 
 <div className="space-y-2 mb-12">
 <p className="text-primary font-bold text-sm uppercase tracking-widest">
 Redirecting to your dashboard shortly...
 </p>
 <div className="w-48 h-1 bg-primary/20 rounded-full mx-auto overflow-hidden">
 <div className="h-full bg-primary animate-marquee"></div>
 </div>
 </div>
 
 <button
   onClick={() => navigate('/dashboard')}
   className="btn-primary-gradient px-10 py-4 text-lg shadow-xl hover:scale-105 active:scale-95 transition-all inline-flex items-center gap-2"
 >
 🏠 Go to Dashboard Now
 </button>
 </div>
 </div>
 );
};
 
export default ThankYouPage;
 
 



